import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
	constructor(m) {
		super(m);
		this.body = document.querySelector('body'); // Corregido: 'this.body'
	}

	init() {
		const button = this.el;
		const header = document.querySelector('header');
		const nav = document.querySelector('.theme-nav');

		// Flags para distinguir apertura por teclado y evitar dobles toggles
		this._lastInteractionWasKeyboard = false;
		this._toggleLock = false;
		this._focusTargetOnClose = null;

		// Abrir/activar menú con teclado (Enter / Space)
		button.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
				e.preventDefault();
				this._lastInteractionWasKeyboard = true;
				if (this._toggleLock) return;
				this._toggleLock = true;
				setTimeout(() => { this._toggleLock = false; }, 300);
				button.click();
			}
		});
		button.addEventListener('click', (evt) => {


		// Observador para cambios en aria-expanded por si otros módulos abren/capitan el menú
		this._menuObserver = new MutationObserver((mutations) => {
			for (const m of mutations) {
				if (m.attributeName === 'aria-expanded') {
					const expanded = button.getAttribute('aria-expanded') === 'true';
					if (expanded) {					// Si al abrir el menú hay un buscador abierto, pedir su cierre (paridad con comportamiento previo)
					const openSearchOnOpen = document.querySelector('button[data-module-searchbox][aria-expanded="true"]') || (document.getElementById('searchBox') && document.getElementById('searchBox').getAttribute('aria-hidden') === 'false');
					if (openSearchOnOpen) {
						document.dispatchEvent(new CustomEvent('search:close'));
					}						// Solo mover foco si la apertura fue por teclado
						if (this._lastInteractionWasKeyboard) {
							this.focusFirstMenuItem();
							this._lastInteractionWasKeyboard = false;
						}
						// Siempre configurar el trap para navegación por teclado
						this.setupFocusTrap();
					} else {
						this.removeFocusTrap();
						// Si hay un objetivo de foco pendiente (por ejemplo Tab fuera), fócalo
						if (this._focusTargetOnClose) {
							const target = this._focusTargetOnClose;
							this._focusTargetOnClose = null;
							setTimeout(() => { try { target.focus(); } catch (e) {} }, 10);
						}
					}
				}
			}
		});
		this._menuObserver.observe(button, { attributes: true, attributeFilter: ['aria-expanded'] });			// Si el buscador está abierto, pedir su cierre antes de abrir el menú para evitar dos botones de cerrar
			const openSearch = document.querySelector('button[data-module-searchbox][aria-expanded="true"]');

			const proceedToggle = () => {

				let isExpanded = button.getAttribute('aria-expanded') === 'true'; // Corrige la comparación
				button.setAttribute('aria-expanded', String(!isExpanded)); // Invierte el estado y guarda string
				isExpanded = button.getAttribute('aria-expanded') === 'true'; // Actualiza el estado
				nav.classList.toggle('open', isExpanded);
				nav.setAttribute('aria-hidden', String(!isExpanded));
				header.classList.toggle('open', isExpanded);
				this.body.classList.toggle('no-scroll', isExpanded); // Corregido: 'this.body'

				const label = button.querySelector('.menu-label');
				const openText = button.dataset.openText || 'Menu';
				const closeText = button.dataset.closeText || 'Cerrar';

				if (label) {
					label.textContent = isExpanded ? closeText : openText;
					button.setAttribute('aria-label', isExpanded ? closeText : openText);
				}

				if (isExpanded) {
					this.hideScroll();
					// En apertura: solo mover foco si la apertura fue por teclado
					if (this._lastInteractionWasKeyboard) {
						this.focusFirstMenuItem();
						this._lastInteractionWasKeyboard = false;
					}
					// Configurar trap de foco (necesario para navegación por teclado)
					this.setupFocusTrap();
				} else {
					this.showScroll();
					this.removeFocusTrap();
					// Devolver foco al botón al cerrar (por defecto)
					button.focus();
				}
			};

			if (openSearch || (document.getElementById('searchBox') && document.getElementById('searchBox').getAttribute('aria-hidden') === 'false')) {
				// Pedir cierre al módulo de búsqueda (mantenemos módulos desacoplados)
				document.dispatchEvent(new CustomEvent('search:close'));
				let fallbackTimer;
				const onClosed = () => {
					clearTimeout(fallbackTimer);
					document.removeEventListener('search:closed', onClosed);
					proceedToggle();
				};
				document.addEventListener('search:closed', onClosed);
				// fallback in case something fails (safety)
				fallbackTimer = setTimeout(() => {
					document.removeEventListener('search:closed', onClosed);
					proceedToggle();
				}, 600);
				return;
			}

			// Si no hay buscador abierto, proceder directamente
			proceedToggle();
		});
	}

	/**
	 * Mueve el foco al primer elemento focuseable del menú
	 */
	focusFirstMenuItem() {
		const nav = document.querySelector('.theme-nav');
		if (!nav) return;

		// Espera un frame y un pequeño retardo para asegurarnos de que el menú esté visible (animaciones)
		requestAnimationFrame(() => {
			let attempts = 0;
			const tryFocus = () => {
				// Busca el primer link o botón enfocable y visible en el menú
				const focusableElements = Array.from(nav.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])'))
					.filter(el => el.offsetParent !== null || el.getClientRects().length);
				if (focusableElements.length > 0) {
						focusableElements[0].focus();
					return true;
				}
				return false;
			};

			// primer intento inmediato con pequeño retardo
			setTimeout(() => {
				if (!tryFocus()) {
					// reintenta varias veces en caso de animaciones/delays
					const interval = setInterval(() => {
						attempts++;
						if (tryFocus() || attempts > 6) {
							clearInterval(interval);
						}
					}, 80);
				}
			}, 30);
		});
	}

	/**
	 * Configura el trap de foco para el menú móvil
	 */
	setupFocusTrap() {
		const nav = document.querySelector('.theme-nav');
		const button = this.el;
		if (!nav) return;

		this.focusTrapHandler = (e) => {
			if (button.getAttribute('aria-expanded') !== 'true') return;

				const focusableElements = Array.from(nav.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])'))
					.filter(el => el.offsetParent !== null || el.getClientRects().length);
				if (focusableElements.length === 0) return;

				const firstElement = focusableElements[0];
				const lastElement = focusableElements[focusableElements.length - 1];

				const getAllFocusable = () => Array.from(document.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
					.filter(el => el.offsetParent !== null || el.getClientRects().length);

				const findNext = (el) => {
					// Preferir el logo si existe en el header (caso solicitado)
					const logoImg = document.querySelector('header img[src*="logo"]');
					const logoAnchor = logoImg ? logoImg.closest('a') : null;
					if (logoAnchor) return logoAnchor;
					const all = getAllFocusable();
					const idx = all.indexOf(el);
					return (idx >= 0 && idx < all.length - 1) ? all[idx + 1] : null;
				};

				const findPrev = (el) => {
					const all = getAllFocusable();
					const idx = all.indexOf(el);
					return (idx > 0) ? all[idx - 1] : null;
				};

				// Si presiona Escape en cualquier momento dentro del trap, cerrar el menú y devolver foco al botón
				if (e.key === 'Escape' || e.key === 'Esc') {
					e.preventDefault();
					this._focusTargetOnClose = button;
					button.click();
					setTimeout(() => { try { button.focus(); } catch (er) {} }, 50);
					return;
				}

				// Si presiona Tab desde el último elemento, cierra el menú y mueve foco al siguiente elemento del DOM
				if (e.key === 'Tab' && !e.shiftKey && document.activeElement === lastElement) {
					e.preventDefault();
					const next = findNext(lastElement);
					const target = next || null;
					this._focusTargetOnClose = target;
					button.click(); // Cierra el menú; el observer se encargará de enfocar el objetivo
					// Fallback: si por alguna razón no se ejecuta el observer, enfocar después de cierre pasado un pequeño retardo
					setTimeout(() => {
						if (target && button.getAttribute('aria-expanded') === 'false') {
							try { target.focus(); } catch (e) {}
							this._focusTargetOnClose = null;
						}
					}, 200);
				}
				// Si presiona Shift+Tab desde el primer elemento, cierra el menú y mueve foco al elemento anterior del DOM
				else if (e.key === 'Tab' && e.shiftKey && document.activeElement === firstElement) {
					e.preventDefault();
					const prev = findPrev(firstElement);
					const targetPrev = prev || null;
					this._focusTargetOnClose = targetPrev;
					button.click();
					setTimeout(() => {
						if (targetPrev && button.getAttribute('aria-expanded') === 'false') {
							try { targetPrev.focus(); } catch (e) {}
							this._focusTargetOnClose = null;
						}
					}, 200);
				}
			};
			document.addEventListener('keydown', this.focusTrapHandler);
	}

	/**
	 * Remueve el trap de foco del menú
	 */
	removeFocusTrap() {
		if (this.focusTrapHandler) {
			document.removeEventListener('keydown', this.focusTrapHandler);
			this.focusTrapHandler = null;
		}
	}

	// Función para ocultar el scroll y guardar la posición
	hideScroll() {
		/* this.body.dataset.scrollPosition = window.scrollY;
		this.body.style.overflow = 'hidden';
		this.body.style.position = 'fixed';
		this.body.style.top = `-${window.scrollY}px`; */
	}

	// Función para mostrar el scroll y restaurar la posición
	showScroll() {
		const scrollPosition = this.body.dataset.scrollPosition; // Corregido: 'this.body'
		this.body.style.overflow = '';
		this.body.style.position = '';
		this.body.style.top = '';
		window.scrollTo(0, Number(scrollPosition)); // Asegúrate de convertir a número
	}
}
